/** The square buttons beside the footer bar: Help and network status. */
export const FOOTER_SQUARE_CLASS =
	'flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-lg bg-sidebar-accent/50 transition-colors data-[state=open]:bg-sidebar-accent'
